/**
 * Checkbox Component
 * Styled checkbox with label
 */

import React, { forwardRef } from 'react';

import './checkbox.scss';

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
    label: React.ReactNode;
    error?: boolean;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
    ({ label, error, id, className = '', ...props }, ref) => {
        const wrapperClasses = ['checkbox', error && 'checkbox--error', className].filter(Boolean).join(' ');

        return (
            <label htmlFor={id} className={wrapperClasses}>
                <input ref={ref} type="checkbox" id={id} className="checkbox__input" {...props} />
                <span className="checkbox__control">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                        <polyline points="20 6 9 17 4 12" />
                    </svg>
                </span>
                <span className="checkbox__label">{label}</span>
            </label>
        );
    },
);

Checkbox.displayName = 'Checkbox';

export default Checkbox;
